/* @flow */
import * as React from 'react';
import type { TFunction } from 'react-i18next';
import type { ImportRowError } from 'api/brandsBulkImport';
import styles from './ImportShared.module.scss';
import { formatNullable } from './formatters';

type TypeProps = {
  errors: ImportRowError[],
  variant: 'error' | 'warning',
  t: TFunction,
};

const ImportErrorList = ({ errors, variant, t }: TypeProps): React.Node => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <ul className={`${styles['import-error-list']} ${styles[`import-error-list--${variant}`]}`}>
      {errors.map((error: ImportRowError) => (
        <li
          key={`${error.row}-${error.field}-${error.message}`}
          className={styles['import-error-list__item']}
        >
          <span className={styles['import-error-list__row']}>
            {t('general:reporting.brand_form.multiple.labels.row_number', { row: error.row })}
          </span>
          <span className={styles['import-error-list__field']}>{error.field}</span>
          <span className={styles['import-error-list__value']}>{formatNullable(error.value)}</span>
          <span className={styles['import-error-list__message']}>{error.message}</span>
        </li>
      ))}
    </ul>
  );
};

export default ImportErrorList;
